<script>
  import { XIcon } from 'vue-feather-icons'

  export default {
    components: {
      XIcon
    },
    props: {
      staff: {
        type: Object,
        required: true
      },
      validation: {
        type: [Array , Object],
        required: true
      },
      disableEdit:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        attachments: [],
      }
    },
    watch:{
      deep: true,
      attachments(){
        if (this.attachments.length !== 0){
          this.$set(this.staff, 'avatar', this.attachments[0].url)
        }else{
          this.$set(this.staff, 'avatar', '')
        }
      }
    },
    async mounted(){
      if (this.staff.avatar && this.staff.avatar.length !== 0){
        this.attachments.push({url: this.staff.avatar})
      }
    },
    methods: {
      handlerFilter() {
        this.$emit('input', this.staff)
      },
      parseUpload() {
        if (this.attachments.length === 0 || this.attachments.length === 1){
          return
        }
        this.$set(this, 'attachments', this.attachments.splice((this.attachments.length - 1), 1))
      },
    }
  }
</script>

<template>
  <div class="form-content pt-1">
    <div class="tw-flex tw-flex-col md:tw-flex-row">
      <div :class="['tw-w-full md:tw-w-1/2 md:tw-pr-2', 'form-group', { 'is-invalid': validation.first_name }] ">
        <label class="label-control">First Name*</label>
        <input
          v-model="staff.first_name"
          type="text"
          class="form-control"
          placeholder=""/>
        <div class="text-danger">
          {{ validation.first_name }}
        </div>
      </div>

      <div :class="['tw-w-full md:tw-w-1/2 md:tw-pl-2', 'form-group', { 'is-invalid': validation.last_name }] ">
        <label class="label-control">Last Name*</label>
        <input
          v-model="staff.last_name"
          type="text"
          class="form-control"
          placeholder=""/>
        <div class="text-danger">
          {{ validation.last_name }}
        </div>
      </div>
    </div>
    <div class="form-group mg-b-u">
      <label class="label-control">Avatar</label>
      <div v-for="(file, index) in attachments" :key="index" class="edit-form-item mg-b-20">
        <div class="item-info">
          <div class="col-md-12 left-ct">
            <div class="image-ct">
              <img
                :src="file.url"
                class="rounded-circle image-avatar"
                width="45"
                height="45"/>
            </div>
          </div>
        </div>
        <div
          v-if="!disableEdit"
          class="action-group mg-l-auto tw-flex-shrink-1">
          <button type="button" class="btn btn-icon button-action button-action-negative btn-highlight" @click="attachments.splice(index, 1)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>
      <div
        v-if="!disableEdit">
        <div class="upload-box">
          <FabricUploader
            v-model="attachments"
            :allow-multiple="true"
            label-idle="Drop files here to upload"
            accepted-file-types="image/jpeg, image/png"
            @uploadCompleted="parseUpload"
          />
        </div>
      </div>
    </div>
  </div>
</template>
